const state = {
  all: [],
  loading: false
}

const getters = {
  all: state => state.all,
  find: state => state.all.find(opportunity => opportunity.id == Vue.$route.params.id),
  loading: state => state.loading
}

const mutations = {
  setAll(state, users) {
    state.all = users
  },
  set(state, user) {
    const find = state.all.find(o => o.id == user.id)
    if (find) state.all.splice(state.all.indexOf(find), 1, user)
    if (!find) state.all.push(user)
  },
  startLoading(state) {
    state.loading = true
  },
  stopLoading(state) {
    state.loading = false
  }
}

const actions = {
  fetchAll({ commit }) {
    commit('startLoading')
    return Vue.$http
      .get(`client/clients`)
      .then(({ data }) => {
        commit('stopLoading')
        commit('setAll', data)
      })
      .catch(error => {
        commit('stopLoading')
        return error
      })
  },
  fetch({ commit, getters }, id) {
    commit('startLoading')
    return Vue.$http
      .get(`client/clients/${id}`)
      .then(({ data }) => {
        commit('stopLoading')
        commit('set', data)
      })
      .catch(error => {
        commit('stopLoading')
        return error
      })
  },
  update({ commit, getters }, user) {
    commit('startLoading')
    return Vue.$http
      .patch(`client/clients/${user.id}`, user)
      .then(({ data }) => {
        commit('stopLoading')
        commit('set', data)
      })
      .catch(error => {
        commit('stopLoading')
        return error
      })
  },
  create({ commit, getters }, user) {
    commit('startLoading')
    return Vue.$http.post('client/clients', user).then(
      ({ data }) => {
        commit('stopLoading')
        commit('set', data)
        return data
      },
      errors => {
        commit('stopLoading')
        return errors
      }
    )
  },
  invite({ commit, getters }, user) {
    return Vue.$http.post(`client/clients/${user.id}/invite`, user).then(
      response => {
        commit('set', response.data)
        return response
      },
      errors => {
        return errors
      }
    )
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
